module.exports = __webpack_public_path__ + "static/media/Catalogo-Gasolina.015d0871.png";